import { selectUserBookings } from '../userBookings/selectors'
import { createSelector } from 'reselect'
import { convertBookingsToTableRecords } from './utils'

export const selectBookingsTableRecords = createSelector(
  selectUserBookings,
  convertBookingsToTableRecords
)
